module.exports = __webpack_public_path__ + "img/Carte-platinum-noire.0834b213.png";